function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Link"
}, React.createElement("path", {
  className: "cls-1",
  d: "M7.023,10.368l-.92.92A2.4,2.4,0,0,1,2.712,7.9l.92-.92A1.005,1.005,0,0,0,2.21,5.556l-.919.92a4.407,4.407,0,1,0,6.233,6.233l.92-.919a1.005,1.005,0,0,0-1.421-1.422Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M7.711,4.868,4.868,7.711A1,1,0,0,0,6.289,9.132L9.132,6.289A1,1,0,0,0,7.711,4.868Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M12.709,1.291a4.407,4.407,0,0,0-6.233,0l-.92.919A1.005,1.005,0,0,0,6.977,3.632l.92-.92A2.4,2.4,0,0,1,11.288,6.1l-.92.92A1.005,1.005,0,0,0,11.79,8.444l.919-.92a4.407,4.407,0,0,0,0-6.233Z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/link.54963f45.svg";
export { SvgComponent as ReactComponent };